import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
  transform(value: string, args?: [number?, string?]): string {
    if (!value) return value;

    let [limit, trail] = args || [];

    limit ??= 20;
    trail ??= '...';

    return value.length > limit ? value.trim().substring(0, limit) + trail : value.trim();
  }
}
